import request from '@/config/axios'

/** 旧版礼物 CRUD（兼容） */
export interface LiveGiftVO {
  id?: number
  name?: string
  iconUrl?: string
  svgaUrl?: string
  price?: number
  sort?: number
  status?: number
}

/** 礼物目录（catalog） */
export interface LiveGiftCatalogVO {
  id?: number
  name: string
  picUrl?: string
  intro?: string
  svgaUrl?: string
  effectKey?: string
  coinPrice?: number
  enabled?: boolean
  sort?: number
  /** 兼容旧字段 */
  iconUrl?: string
  price?: number
  status?: number
}

export interface LiveGiftRecordVO {
  id?: number
  liveId?: number
  userId?: number
  /** 送礼会员账号展示 */
  senderAccount?: string
  giftId?: number
  giftName?: string
  giftPic?: string
  quantity?: number
  amount?: number
  anchorUserId?: number
  /** 主播会员账号展示 */
  anchorAccount?: string
  anchorCoin?: number
  /** 金币转化比例（百分比，如 70） */
  coinShareRatioPercent?: number
  createTime?: string
}

export const pageGift = (params: any) => request.get({ url: '/live/gift/page', params })
export const getGift = (id: number) =>
  request.get({ url: '/live/gift/get', params: { id } })
export const createGift = (data: LiveGiftVO) =>
  request.post({ url: '/live/gift/create', data })
export const updateGift = (data: LiveGiftVO) =>
  request.put({ url: '/live/gift/update', data })
export const deleteGift = (id: number) =>
  request.delete({ url: '/live/gift/delete', params: { id } })

export const catalogPage = (params: any) =>
  request.get({ url: '/live/gift/catalog/page', params })
export const saveCatalog = (data: LiveGiftCatalogVO) =>
  request.post({ url: '/live/gift/catalog/save', data })
export const deleteCatalog = (id: number) =>
  request.delete({ url: '/live/gift/catalog/delete', params: { id } })
export const recordPage = (params: any) => request.get({ url: '/live/gift/record/page', params })
export const deleteRecord = (id: number) =>
  request.delete({ url: '/live/gift/record/delete', params: { id } })
